import React, { useState } from "react";
import { Button, Popconfirm, Tooltip } from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import { SizeType } from "antd/es/config-provider/SizeContext";

interface IRemoveRecordProps {
  title: string;
  onConfirm: (callback: () => void) => void;
  okText: string;
  cancelText: string;
  tooltipText: string;
  additionalClass?: string;
  size?: SizeType;
}

const defaultProps = {
  additionalClass: "",
  size: "middle",
};

const RemoveRecord = (props: IRemoveRecordProps): JSX.Element => {
  const [visible, setVisible] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const {
    title,
    onConfirm,
    okText,
    cancelText,
    tooltipText,
    additionalClass,
    size,
  } = props;

  const handleConfirm = () => {
    setLoading(true);
    onConfirm(() => {
      setVisible(false);
      setLoading(false);
    });
  };

  return (
    <Popconfirm
      visible={visible}
      placement="topLeft"
      title={title}
      style={{ maxWidth: "300px" }}
      okButtonProps={{ loading: isLoading }}
      onConfirm={handleConfirm}
      okText={okText}
      cancelText={cancelText}
      onCancel={() => setVisible(false)}
    >
      <Tooltip title={tooltipText} mouseEnterDelay={1}>
        <Button
          size={size}
          className={additionalClass}
          onClick={() => setVisible(true)}
          icon={<DeleteOutlined />}
        />
      </Tooltip>
    </Popconfirm>
  );
};

RemoveRecord.defaultProps = defaultProps;
export default RemoveRecord;
